<template>
  <div class="reaction-selector">
    <v-icon
      v-for="r in reactions"
      :key="r.token"
      small
      @click="handleClick(r)"
      :class="'reaction-icon material-icons reaction-icon-' + r.iconName"
      >{{ r.iconName }}</v-icon
    >
  </div>
</template>
<script>
import Vue from "vue";
import { REACTIONS } from "@/helpers/chat";

export default Vue.extend({
  name: "ReactionSelector",
  props: ["actionLabel", "onAction"],
  methods: {
    handleClick(reaction) {
      this.$emit("react", reaction);
    }
  },
  computed: {
    reactions() {
      return REACTIONS.toList();
    }
  }
});
</script>
<style scoped>
.reaction-selector {
  background-color: white;
  max-width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 6px;
  padding-right: 4px;
  overflow: hidden;
}
.reaction-icon {
  padding: 10px;
}
.reaction-icon:hover {
  background-color: #efefef;
}
</style>
